import { Suspense } from 'react'
import { SpinnerFullHeight } from '../../../components/spinner/SpinnerFullHeight'
import { ApplyFiltersButton, CountryFilter, DatesPicker, ToggleDbResponders } from '../Filters'
import { GeneralStatsPageAllProjects } from './GeneralAllProjects'

export const StatsPageAllProjects = () => {
  return (
    <>
      <div className="w-100 bg-primary d-flex justify-content-center position-relative" style={{ height: 2 }}></div>
      <div className="container-fluid bg-white">
        <div className="container">
          <div className="row" style={{ paddingBottom: 18 }}>
            <div className="col-4">
              <h3 className="fw-bold mt-4">All Projects</h3>
              <p className="fw-bold opacity-75">Stats</p>
            </div>
            <div className="col-3">
              <div
                className="mt-4"
                style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column' }}
              >
                <div>
                  <DatesPicker />
                </div>
                <div className="mt-2">
                  <ToggleDbResponders />
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="mt-4">
                <CountryFilter />
              </div>
            </div>
            <div className="col-1">
              <div className="mt-4">
                <Suspense fallback={<SpinnerFullHeight />}>
                  <ApplyFiltersButton />
                </Suspense>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<SpinnerFullHeight />}>
        <div className="container mt-2 mb-4">
          <div className="row" style={{}}>
            <div className="col-12">
              <div className="d-flex justify-content-around">
                {/* wrap tabs here*/}
                <GeneralStatsPageAllProjects />
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </>
  )
}
